import { render, staticRenderFns } from "./InvestmentAccountClose.vue?vue&type=template&id=de64089c&scoped=true"
import script from "./InvestmentAccountClose.vue?vue&type=script&lang=ts"
export * from "./InvestmentAccountClose.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentAccountClose.vue?vue&type=style&index=0&id=de64089c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de64089c",
  null
  
)

export default component.exports